<template>
  <div class="wrapper">
    <router-view></router-view>

    <div class="animated fadeIn">
      <div class="card">
        <div class="card-header font-weight-bold">Blocage activité B2C</div>
        <div class="card-block">
          <div class="row d-flex flex-row align-items-center">
            <div class="col-sm-3">
              <template
                >Bloquer planification et validation
                <el-popover
                  placement="top-start"
                  :width="400"
                  trigger="hover"
                  content="Si ce réglage est activé, les coachs ne peuvent plus planifier ni valider de séances pour les clients B2C depuis leur app. La planification et la validation depuis le manager restent actives."
                >
                  <span slot="reference">
                    <i class="fa fa-info-circle"></i>
                  </span> </el-popover
              ></template>
            </div>

            <div class="col-sm-9">
              <el-switch
                v-model="settings['suspend_b2c_coach_activity']"
                @change="handleChange('suspend_b2c_coach_activity', $event)"
                v-if="hasPermission($store.state.user, 'SETTINGS_CONFIG_WRITE')"
                active-text="Oui"
                inactive-text="Non"
              />

              <span v-else>{{
                settings["suspend_b2c_coach_activity"] ? "Oui" : "Non"
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header font-weight-bold">Inactivité</div>

        <div class="card-block">
          <div class="row d-flex flex-row align-items-center">
            <div class="col-sm-3">Statut actif intervenant</div>
            <div class="col-sm-9">
              <el-input-number
                size="small"
                :min="0"
                v-model="settings['days_active_intervenant']"
                @change="handleChange('days_active_intervenant', $event)"
                v-if="hasPermission($store.state.user, 'SETTINGS_CONFIG_WRITE')"
              ></el-input-number>
              <span v-else>{{ settings["days_active_intervenant"] }}</span>
              <span class="ml-1"
                >Jours (durée sans séance validée en X jours)</span
              >
            </div>
          </div>

          <hr />

          <div class="row d-flex flex-row align-items-center">
            <div class="col-sm-3">Statut actif client</div>
            <div class="col-sm-9">
              <el-input-number
                size="small"
                :min="0"
                v-model="settings['days_active_client']"
                @change="handleChange('days_active_client', $event)"
                v-if="hasPermission($store.state.user, 'SETTINGS_CONFIG_WRITE')"
              ></el-input-number>
              <span v-else>{{ settings["days_active_client"] }}</span>
              <span class="ml-1"
                >Jours (durée sans séance validée en X jours)</span
              >
            </div>
          </div>

          <hr />

          <div class="row d-flex flex-row align-items-center">
            <div class="col-sm-3">
              <template>
                Statut perdu client
                <el-popover
                  placement="top-start"
                  :width="400"
                  trigger="hover"
                  content="modifie le statut du client en perdu pour tous les clients actifs, inactifs et non archivés avec au moins un pack terminé depuis plus de X jours"
                >
                  <span slot="reference">
                    <i class="fa fa-info-circle"></i>
                  </span>
                </el-popover>
              </template>
            </div>

            <div class="col-sm-9">
              <el-input-number
                size="small"
                :min="0"
                v-model="settings['days_lost_client']"
                @change="handleChange('days_lost_client', $event)"
                v-if="hasPermission($store.state.user, 'SETTINGS_CONFIG_WRITE')"
              ></el-input-number>
              <span v-else>{{ settings["days_lost_client"] }}</span>
              <span class="ml-1"
                >Jours (durée avec un pack terminé depuis X jours)</span
              >
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header font-weight-bold">
          Configuration rappel avoir coach (1er de chaque mois)
        </div>
        <div class="card-block">
          <div class="row d-flex flex-row align-items-center">
            <div class="col-sm-3">Prévenir par email à partir de</div>

            <div class="col-sm-9">
              <el-input-number
                size="small"
                :min="0"
                v-model="settings['reminder_credit_amount']"
                @change="handleChange('reminder_credit_amount', $event)"
                v-if="hasPermission($store.state.user, 'SETTINGS_CONFIG_WRITE')"
              ></el-input-number>

              <span v-else>{{ settings["reminder_credit_amount"] }}</span>

              <span class="ml-1">euros</span>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header font-weight-bold">
          <div class="d-flex justify-content-between align-items-center">
            <div><span>Facturation coach</span><br /></div>
          </div>
        </div>

        <div class="card-block">
          <div class="row d-flex flex-row align-items-center">
            <div class="col-sm-3">
              Débloquer la création de facture à partir de
            </div>

            <div class="col-sm-9">
              <el-input-number
                size="small"
                :min="0"
                v-model="settings['minimum_credit_amount']"
                @change="handleChange('minimum_credit_amount', $event)"
                v-if="hasPermission($store.state.user, 'SETTINGS_CONFIG_WRITE')"
              ></el-input-number>

              <span v-else>{{ settings["minimum_credit_amount"] }}</span>

              <span class="ml-1">euros</span>
            </div>
          </div>

          <hr />

          <div class="row d-flex flex-row align-items-center">
            <div class="col-sm-3">Bloquer la facturation unique par mois</div>
            <div class="col-sm-9">
              <el-switch
                v-model="settings['month_lock_credit']"
                @change="handleChange('month_lock_credit', $event)"
                v-if="hasPermission($store.state.user, 'SETTINGS_CONFIG_WRITE')"
                active-text="Oui"
                inactive-text="Non"
              />
              <span v-else>{{
                settings["month_lock_credit"] ? "Oui" : "Non"
              }}</span>
            </div>
          </div>

          <hr />

          <div class="row">
            <div class="col-sm-3">Activer la période de facturation</div>
            <div class="col-sm-9">
              <el-switch
                v-if="hasPermission($store.state.user, 'SETTINGS_CONFIG_WRITE')"
                v-model="settings['coach_disbursement_period_active']"
                active-text="Oui"
                inactive-text="Non"
                @change="
                  handleChange('coach_disbursement_period_active', $event)
                "
              />
              <span v-else>{{
                settings["coach_disbursement_period_active"] ? "Oui" : "Non"
              }}</span>
            </div>
          </div>

          <hr />

          <div class="row">
            <div class="col-sm-3">Période de facturation</div>
            <div v-if="settings['coach_disbursement_period']" class="col-sm-9">
              <span>Du</span>
              <el-select
                v-if="hasPermission($store.state.user, 'SETTINGS_CONFIG_WRITE')"
                v-model="settings['coach_disbursement_period'][0]"
                size="mini"
                class="mx-1"
                @change="
                  handleChange('coach_disbursement_period', [
                    $event,
                    settings['coach_disbursement_period'][1],
                  ])
                "
              >
                <el-option
                  v-for="monthDay in monthDayOptions"
                  :value="monthDay"
                  :key="`coach-disbursement-period-start-${monthDay}`"
                  >{{ monthDay }}</el-option
                >
              </el-select>
              <span v-else class="mx-1">{{
                settings["coach_disbursement_period"][0]
              }}</span>
              <span>au</span>
              <el-select
                v-if="hasPermission($store.state.user, 'SETTINGS_CONFIG_WRITE')"
                v-model="settings['coach_disbursement_period'][1]"
                size="mini"
                class="mx-1"
                @change="
                  handleChange('coach_disbursement_period', [
                    settings['coach_disbursement_period'][0],
                    $event,
                  ])
                "
              >
                <el-option
                  v-for="monthDay in monthDayOptions"
                  :value="monthDay"
                  :key="`coach-disbursement-period-end-${monthDay}`"
                  >{{ monthDay }}</el-option
                >
              </el-select>
              <span v-else class="mx-1">{{
                settings["coach_disbursement_period"][1]
              }}</span>
              <span>inclus</span>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header font-weight-bold">Validation des séances</div>
        <div class="card-block">
          <div class="row">
            <div class="col-sm-3">Validation par code (B2C)</div>
            <div class="col-sm-9">
              <el-select
                v-if="hasPermission($store.state.user, 'SETTINGS_CONFIG_WRITE')"
                v-model="settings['session_validation_by_code']"
                size="mini"
                @change="handleChange('session_validation_by_code', $event)"
              >
                <el-option label="Activée" value="enabled" />
                <el-option label="Échantillon test" value="prelaunch" />
                <el-option label="Désactivée" value="disabled" />
              </el-select>

              <span v-else>
                {{
                  settings["session_validation_by_code"] === "enabled"
                    ? "Activée"
                    : settings["session_validation_by_code"] === "prelaunch"
                    ? "Échantillon test"
                    : "Désactivée"
                }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header font-weight-bold">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <span
                >Configuration d'envoi d'un email de notation aux clients</span
              ><br />
            </div>
          </div>
        </div>

        <div class="card-block">
          <div class="row d-flex flex-row align-items-center">
            <div class="col-sm-3">
              Prévenir par email à partir de
              <el-popover
                placement="top-start"
                :width="400"
                trigger="hover"
                content="Un email de demande de notation de coach sera envoyé au client toutes les X séances validées, la boucle est stoppé lorsque le coach est noté. La boucle reprendra à chaque nouveau coach."
              >
                <span slot="reference">
                  <i class="fa fa-info-circle"></i>
                </span>
              </el-popover>
            </div>

            <div class="col-sm-9">
              <el-input-number
                size="small"
                :min="0"
                v-model="settings['frequency_sending_rating_emails_to_client']"
                @change="
                  handleChange(
                    'frequency_sending_rating_emails_to_client',
                    $event,
                  )
                "
                v-if="hasPermission($store.state.user, 'SETTINGS_CONFIG_WRITE')"
              ></el-input-number>

              <span v-else>{{ settings["reminder_credit_amount"] }}</span>

              <span class="ml-1">séances</span>
            </div>
          </div>

          <hr />

          <div class="row d-flex flex-row align-items-center">
            <div class="col-sm-3">Bloquer l'envoi d'email</div>
            <div class="col-sm-9">
              <el-switch
                v-model="settings['lock_sending_rating_emails_to_client']"
                @change="
                  handleChange('lock_sending_rating_emails_to_client', $event)
                "
                v-if="hasPermission($store.state.user, 'SETTINGS_CONFIG_WRITE')"
                active-text="Oui"
                inactive-text="Non"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header font-weight-bold">
          <div class="d-flex justify-content-between align-items-center">
            <div><span>Cache</span><br /></div>
            <button class="btn btn-primary" @click="flushCache()">
              Vider le cache
            </button>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header font-weight-bold">
          <div class="d-flex justify-content-between align-items-center">
            <div><span>Memory Leak</span><br /></div>
            <div>
              <button class="btn btn-primary" @click="downloadMemoryUsage">
                Télécharger le rapport de fuite mémoire
              </button>
              <button class="ml-2 btn btn-primary" @click="takeHeapSnapshot">
                Prendre un snapshot mémoire (voir serveur)
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      settings: {},
      monthRankOptions: [
        {
          label: "1 mois",
          value: 1,
        },
        {
          label: "2 mois",
          value: 2,
        },
        {
          label: "3 mois",
          value: 3,
        },
        {
          label: "4 mois",
          value: 4,
        },
        {
          label: "5 mois",
          value: 5,
        },
        {
          label: "6 mois",
          value: 6,
        },
        {
          label: "1 an",
          value: 12,
        },
        {
          label: "2 ans",
          value: 24,
        },
        {
          label: "Depuis le début",
          value: "all",
        },
      ],
      monthDayOptions: Array.from({ length: 31 }, (_, i) => i + 1),
    };
  },
  methods: {
    async fetchSettings() {
      const { data } = await this.$api.get("/settings");

      this.settings = data;
      this.settings["coach_disbursement_period"] = this.settings[
        "coach_disbursement_period"
      ] || [null, null];
    },

    async handleChange(key, value) {
      const { data } = await this.$api
        .patch("/settings", { [key]: value })
        .catch((e) => {
          this.$errorToast(`Erreur lors de la sauvegarde des paramètre: ${e}`);
        });

      this.settings = {
        ...this.settings,
        ...data,
      };
    },

    async flushCache() {
      try {
        this.$confirm({
          message: "Voulez-vous vraiment vider le cache ?",
          onConfirm: async () => {
            await this.$api.get(`/cache/flush`);
            this.$successToast(`Cache supprimé`);
          },
        });
      } catch (e) {
        this.$errorToast(`Erreur lors de la suppression du cache`);
      }
    },

    async downloadMemoryUsage() {
      try {
        const data = await this.$api.get("/memory/usage");

        const blob = new Blob([JSON.stringify(data, null, 2)], {
          type: "application/json",
        });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");

        link.href = url;
        link.setAttribute("download", "memory-usage-report.json");
        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (e) {
        this.$errorToast(`Erreur lors du téléchargement du rapport: ${e}`);
      }
    },

    async takeHeapSnapshot() {
      try {
        await this.$api.get("/memory/heap-snapshot");

        this.$successToast(
          "Snapshot mémoire pris, consultez les logs du serveur",
        );
      } catch (e) {
        this.$errorToast(`Erreur lors de la prise du snapshot mémoire: ${e}`);
      }
    },
  },
  created() {
    this.fetchSettings();
  },
};
</script>
